<template>
  <mdb-container fluid>
    <Header></Header>
    <Admintopbar />
    <mdb-row>
      <mdb-col>
        <mdb-card class="mt-4">
          <mdb-card-header color="grey accent-3">
            Taskqueue Template Form
            <mdb-btn color="danger" @click="deleteTaskqueueTemplate">DELETE</mdb-btn>
          </mdb-card-header>
          <mdb-card-body>
            <taskqueue-template-form :taskqueueTemplateId="templateId" @taskqueuetemplate-save="$router.replace('/admin/tasks-configs')"/>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import {
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbRow,
  mdbBtn,
} from 'mdbvue';
import Header from '@/components/Header.vue';
import Admintopbar from '@/components/Admintopbar.vue';
import TaskqueueTemplateForm from '@/components/TaskqueueTemplateForm.vue';
import Apicall from '@/libs/Apicall';

export default {
  components: {
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCol,
    mdbBtn,
    mdbContainer,
    mdbRow,
    Header,
    Admintopbar,
    TaskqueueTemplateForm,
  },

  data() {
    return {
      templateId: null,
      loading: false,
    };
  },

  beforeMount() {
    if (this.$route.query.templateId) {
      this.templateId = this.$route.query.templateId;
    }
  },

  methods: {
    deleteTaskqueueTemplate() {
      const api = new Apicall();

      api.call('POST', 'api/task/delete-taskqueue-template', { taskqueueTemplateId: this.templateId })
        .then((response) => {
          if (response.status === 'OK') {
            this.$router.replace('/admin/tasks-configs');
            this.$notify.success({
              message: 'Template deleted',
              position: 'top right',
              timeOut: 5000,
            });
          } else {
            this.$notify.error({
              message: response.msg,
              position: 'top right',
              timeOut: 5000,
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: error.msg,
            position: 'top right',
            timeOut: 5000,
          });
        });
    },
  },
};
</script>

<style>
</style>
